/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/AttributeMappingEditor.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AttributeMappingEditorTestIds = {
  attributeMappingCard: "attribute-mapping-card",
  attributeMappingEditor: "attribute-mapping-editor",
  attributeMappingReadonly: "attribute-mapping-readonly",
  btnAddMapping: "btn-add-mapping",
  btnCancelMappings: "btn-cancel-mappings",
  btnSaveMappings: "btn-save-mappings",
  cardTitleAttributeMappings: "card-title-attribute-mappings",
  colActions: "col-actions",
  colRequired: "col-required",
  colSource: "col-source",
  colTarget: "col-target",
  colTransform: "col-transform",
  colType: "col-type",
  mappingWarningBanner: "mapping-warning-banner",
  readonlyWarningBanner: "readonly-warning-banner",
  btnRemoveMapping: (index: number) => `btn-remove-mapping-${index}`,
  btnRemoveMappingPrefix: () => "btn-remove-mapping-" as TestIdPrefix,
  checkboxRequired: (index: number) => `checkbox-required-${index}`,
  checkboxRequiredPrefix: () => "checkbox-required-" as TestIdPrefix,
  comboboxSource: (index: number) => `combobox-source-${index}`,
  comboboxSourcePrefix: () => "combobox-source-" as TestIdPrefix,
  errorSource: (index: number) => `error-source-${index}`,
  errorSourcePrefix: () => "error-source-" as TestIdPrefix,
  errorTarget: (index: number) => `error-target-${index}`,
  errorTargetPrefix: () => "error-target-" as TestIdPrefix,
  errorTransform: (index: number) => `error-transform-${index}`,
  errorTransformPrefix: () => "error-transform-" as TestIdPrefix,
  inputSource: (index: number) => `input-source-${index}`,
  inputSourcePrefix: () => "input-source-" as TestIdPrefix,
  inputTarget: (index: number) => `input-target-${index}`,
  inputTargetPrefix: () => "input-target-" as TestIdPrefix,
  mappingRow: (index: number) => `mapping-row-${index}`,
  mappingRowPrefix: () => "mapping-row-" as TestIdPrefix,
  readonlyRequired: (index: number) => `readonly-required-${index}`,
  readonlyRequiredPrefix: () => "readonly-required-" as TestIdPrefix,
  readonlyRow: (index: number) => `readonly-row-${index}`,
  readonlyRowPrefix: () => "readonly-row-" as TestIdPrefix,
  readonlySource: (index: number) => `readonly-source-${index}`,
  readonlySourcePrefix: () => "readonly-source-" as TestIdPrefix,
  readonlyTarget: (index: number) => `readonly-target-${index}`,
  readonlyTargetPrefix: () => "readonly-target-" as TestIdPrefix,
  readonlyType: (index: number) => `readonly-type-${index}`,
  readonlyTypePrefix: () => "readonly-type-" as TestIdPrefix,
  selectTransform: (index: number) => `select-transform-${index}`,
  selectTransformPrefix: () => "select-transform-" as TestIdPrefix,
  selectType: (index: number) => `select-type-${index}`,
  selectTypePrefix: () => "select-type-" as TestIdPrefix
} as const;
